import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API_URL from "../../functions/config";
import PandaPickLogoFull from "../../assets/pandalogo.png";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const Dashboard = () => {



  const [attendanceOverview, setAttendanceOverview] = useState([]);

  const [overviewType, setOverviewType] = useState("week");

  const [overviewLoading, setOverviewLoading] = useState(false);

  const [todayAttendance, setTodayAttendance] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState(
    new Date().getMonth() + 1
  );

  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear()
  );


  const [employees, setEmployees] = useState([]);

  const [dashboardData, setDashboardData] = useState({
    totalEmployees: 0,
    presentToday: 0,
    absentToday: 0,
    onLeave: 0,
    attendancePercentage: "0.0",
    averageWorkingSeconds: 0,
    requiredWorkingSeconds: 0

  });


  const auth = localStorage.getItem('user');

  useEffect(() => {
    getEmployees();
    getDashboardAttendance();
    getAttendanceOverview();
  }, [])

  const getEmployees = async () => {

    let result = await fetch(`${API_URL}/employees/${JSON.parse(auth)._id}`, {
      headers: {
        authorization: `bearer ${JSON.parse(localStorage.getItem('token'))}`
      }
    });
    result = await result.json();

    if (Array.isArray(result)) {

      setEmployees(result);

    } else if (Array.isArray(result.data)) {

      setEmployees(result.data);

    } else if (Array.isArray(result.employees)) {

      setEmployees(result.employees);

    } else {

      setEmployees([]);

    }


  }


  const getDashboardAttendance = async () => {

    try {

      const companyId = JSON.parse(auth)._id;

      let result = await fetch(
        `${API_URL}/dashboard-attendance/${companyId}`,
        {
          method: "GET",
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )}`
          }
        }
      );

      result = await result.json();

      if (result.success) {
        setDashboardData(result);
      } else {
        console.error(
          "Dashboard Attendance Error:",
          result.message
        );
      }

    } catch (error) {

      console.error(
        "Dashboard Attendance Error:",
        error
      );

    }
  };


  const absentPercentage =
    dashboardData.totalEmployees > 0
      ? (
        (dashboardData.absentToday /
          dashboardData.totalEmployees) * 100
      ).toFixed(1)
      : "0.0";


  const presentPercentage = Number(dashboardData.attendancePercentage);

  const absentPercentages =
    dashboardData.totalEmployees > 0
      ? (
        (dashboardData.absentToday / dashboardData.totalEmployees) *
        100
      ).toFixed(1)
      : "0.0";

  const leavePercentage =
    dashboardData.totalEmployees > 0
      ? (
        (dashboardData.onLeave / dashboardData.totalEmployees) *
        100
      ).toFixed(1)
      : "0.0";



  const formatWorkingTime = (totalSeconds) => {
    const seconds = Number(totalSeconds) || 0;

    const hours = Math.floor(seconds / 3600);

    const minutes = Math.floor(
      (seconds % 3600) / 60
    );

    const secs = seconds % 60;

    return (
      `${String(hours).padStart(2, "0")}:` +
      `${String(minutes).padStart(2, "0")}:` +
      `${String(secs).padStart(2, "0")}`
    );
  };



  const getAttendanceOverview = async (
    type = overviewType,
    month = selectedMonth,
    year = selectedYear
  ) => {

    try {

      setOverviewLoading(true);

      const user = JSON.parse(
        localStorage.getItem("user")
      );

      const token = JSON.parse(
        localStorage.getItem("token")
      );

      if (!user?._id) {
        return;
      }

      let url =
        `${API_URL}/dashboard-attendance-overview/${user._id}?type=${type}`;

      // Month / Custom Month
      if (
        type === "month" ||
        type === "custom"
      ) {

        url +=
          `&year=${year}&month=${month}`;

      }

      console.log(
        "ATTENDANCE OVERVIEW URL:",
        url
      );

      const response = await fetch(
        url,
        {
          method: "GET",

          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${token}`
          }
        }
      );

      const result =
        await response.json();

      console.log(
        "ATTENDANCE OVERVIEW:",
        result
      );

      if (!response.ok) {

        console.error(
          result.message ||
          "Failed to load attendance overview"
        );

        return;
      }

      if (result.success) {

        setAttendanceOverview(
          result.data || []
        );

      }

    } catch (error) {

      console.error(
        "ATTENDANCE OVERVIEW ERROR:",
        error
      );

    } finally {

      setOverviewLoading(false);

    }

  };



  const exportAttendancePDF = () => {

    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text(
      "Attendance Report",
      14,
      20
    );

    doc.setFontSize(10);

    doc.text(
      `Generated: ${new Date().toLocaleString("en-IN")}`,
      14,
      28
    );

    autoTable(doc, {

      startY: 38,

      head: [[
        "Employee",
        "Date",
        "Status",
        "Check In",
        "Check Out",
        "Working Hours"
      ]],

      body: todayAttendance.map(item => [

        item.name || "-",

        item.date || "-",

        item.status || "-",

        item.checkInTime || "-",

        item.checkOutTime || "-",

        item.workingHours || "00:00:00"

      ])

    });

    doc.save(
      "attendance-report.pdf"
    );
  };


  return (
    <>
      {employees.length === 0 ? (

        <section className="content py-4 bg-light min-vh-100 ">



          <div className="row g-4 mb-4 align-item-center justify-content-center">

            <div className='col-lg-4 text-center'>
              <h1><strong>Welcome</strong> To</h1>
              <hr></hr>
              <img src={PandaPickLogoFull} alt="PandaPick" className='img-fluid' />
            </div>
            <h2 className='text-center'>Please Add Your Employees</h2>

            <div class="col-auto">  <Link to="/add-employee" className='btn btn-success'>Add Employee</Link></div>

          </div>
        </section>

      ) : (

        <section className="content py-4 bg-light min-vh-100">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1">Dashboard</h3>
              <p className="text-muted mb-0">
                Employee attendance overview
              </p>
            </div>

            {/* 
        <button
    className="btn btn-outline-primary btn-sm"
    onClick={exportAttendancePDF}
>
    Export PDF
</button>
*/}

          </div>

          {/* Dashboard Cards */}
          <div className="row g-4 mb-4">

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="text-muted mb-2">Total Employees</p>
                      <h3 className="fw-bold mb-0">{employees.length}</h3>
                      <small className="text-success">
                        Good
                      </small>
                    </div>

                    <div className="bg-primary bg-opacity-10 text-primary rounded-circle p-3">
                      <i class="fa-solid fa-user-tie"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="text-muted mb-2">Present Today</p>
                      <h3 className="fw-bold mb-0">{dashboardData.presentToday}</h3>
                      <small className={dashboardData.attendancePercentage > 50 ? "text-success" : "text-danger"
                      }>
                        {dashboardData.attendancePercentage}% attendance
                      </small>
                    </div>

                    <div className={dashboardData.attendancePercentage > 50 ? "bg-success bg-opacity-10 text-success rounded-circle p-3" :
                      "bg-danger bg-opacity-10 text-success rounded-circle p-3"
                    } >

                      <i className={dashboardData.attendancePercentage > 50 ?
                        "fa-solid fa-arrow-trend-up" :
                        "fa-solid fa-arrow-trend-down"
                      }
                      ></i>



                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="text-muted mb-2">Absent Today</p>
                      <h3 className="fw-bold mb-0">{dashboardData.absentToday}</h3>
                      <small className={absentPercentage < 50 ? "text-success" : "text-danger"
                      }>
                        {absentPercentage}% absent
                      </small>
                    </div>

                    <div className={absentPercentage < 50 ? "bg-success bg-opacity-10 text-success rounded-circle p-3" :
                      "bg-danger bg-opacity-10 text-success rounded-circle p-3"
                    } >
                      <i className={absentPercentage < 50 ?
                        "fa-solid fa-arrow-trend-down" :
                        "fa-solid fa-arrow-trend-up"
                      }
                      ></i>


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="text-muted mb-2">On Leave</p>
                      <h3 className="fw-bold mb-0">{dashboardData.onLeave || 0}</h3>
                      <small className="text-warning">
                        Approved leave
                      </small>
                    </div>

                    <div className="bg-warning bg-opacity-10 text-warning rounded-circle p-3">
                      <i class="fa-solid fa-envelope-circle-check"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Chart + Summary */}
          <div className="row g-3 mb-4">

            <div className="col-lg-8">

              <div className="card border-0 shadow-sm">

                <div className="card-body">

                  <div className="d-flex justify-content-between align-items-center mb-4">

                    <div>
                      <h5 className="fw-bold mb-1">
                        Attendance Overview
                      </h5>

                      <p className="text-muted small mb-0">
                        Daily attendance percentage
                      </p>
                    </div>

                    <select
                      className="form-select form-select-sm w-auto"
                      value={overviewType}
                      onChange={(e) => {

                        const value = e.target.value;

                        setOverviewType(value);

                        if (value === "week") {

                          getAttendanceOverview("week");

                        } else if (value === "month") {

                          const now = new Date();

                          const month =
                            now.getMonth() + 1;

                          const year =
                            now.getFullYear();

                          setSelectedMonth(month);
                          setSelectedYear(year);

                          getAttendanceOverview(
                            "month",
                            month,
                            year
                          );

                        } else if (value === "custom") {

                          getAttendanceOverview(
                            "custom",
                            selectedMonth,
                            selectedYear
                          );

                        }

                      }}
                    >
                      <option value="week">
                        This Week
                      </option>

                      <option value="month">
                        This Month
                      </option>

                      <option value="custom">
                        Custom Month
                      </option>
                    </select>


                    {overviewType === "custom" && (

                      <div className="d-flex gap-2">

                        <select
                          className="form-select form-select-sm"
                          value={selectedMonth}
                          onChange={(e) => {

                            const month =
                              Number(e.target.value);

                            setSelectedMonth(month);

                            getAttendanceOverview(
                              "custom",
                              month,
                              selectedYear
                            );

                          }}
                        >

                          {[
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                          ].map((name, index) => (

                            <option
                              key={index}
                              value={index + 1}
                            >
                              {name}
                            </option>

                          ))}

                        </select>


                        <select
                          className="form-select form-select-sm"
                          value={selectedYear}
                          onChange={(e) => {

                            const year =
                              Number(e.target.value);

                            setSelectedYear(year);

                            getAttendanceOverview(
                              "custom",
                              selectedMonth,
                              year
                            );

                          }}
                        >

                          {Array.from(
                            { length: 11 },
                            (_, index) =>
                              new Date().getFullYear() -
                              5 +
                              index
                          ).map(year => (

                            <option
                              key={year}
                              value={year}
                            >
                              {year}
                            </option>

                          ))}

                        </select>

                      </div>

                    )}

                  </div>





                  {/* GRAPH */}

                  {overviewLoading ? (

                    <div className="text-center py-5">

                      <div
                        className="spinner-border"
                        role="status"
                      />

                    </div>

                  ) : (

                    <div
                      style={{
                        width: "100%",
                        height: "400px"
                      }}
                    >

                      <ResponsiveContainer
                        width="100%"
                        height="100%"
                      >

                        <LineChart
                          data={attendanceOverview}
                          margin={{
                            top: 10,
                            right: 20,
                            left: 0,
                            bottom: 10
                          }}
                        >

                          <CartesianGrid
                            strokeDasharray="3 3"
                          />

                          <XAxis
                            dataKey="date"
                            tickFormatter={(date) => {

                              const d =
                                new Date(
                                  `${date}T00:00:00`
                                );

                              return d.toLocaleDateString(
                                "en-US",
                                {
                                  day: "numeric",
                                  month: "short"
                                }
                              );

                            }}
                          />

                          <YAxis
                            domain={[0, 100]}
                            ticks={[0, 20, 40, 60, 80, 100]}
                            tickFormatter={(value) =>
                              `${value}%`
                            }
                          />

                          <Tooltip
                            formatter={(value) =>
                              [
                                `${value}%`,
                                "Attendance"
                              ]
                            }
                            labelFormatter={(date) => {

                              const d =
                                new Date(
                                  `${date}T00:00:00`
                                );

                              return d.toLocaleDateString(
                                "en-US",
                                {
                                  weekday: "short",
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric"
                                }
                              );

                            }}
                          />

                          <Line
                            type="monotone"
                            dataKey="percentage"
                            strokeWidth={3}
                            dot={{
                              r: 4
                            }}
                            activeDot={{
                              r: 7
                            }}
                          />

                        </LineChart>

                      </ResponsiveContainer>

                    </div>

                  )}

                </div>

              </div>

            </div>


            {/* Attendance Summary */}
            <div className="col-lg-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body">

                  <h5 className="fw-bold mb-4">
                    Today's Summary
                  </h5>

                  <div className="mb-4">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Present</span>
                      <strong>{dashboardData.presentToday}</strong>
                    </div>

                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-success"
                        style={{ width: `${presentPercentage}%` }}
                      ></div>
                    </div>
                    <small className="text-success">{presentPercentage}%</small>
                  </div>

                  <div className="mb-4">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Absent</span>
                      <strong>{dashboardData.absentToday}</strong>
                    </div>

                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-danger"
                        style={{ width: `${absentPercentages}%` }}
                      ></div>
                    </div>

                    <small className="text-danger">{absentPercentages}%</small>

                  </div>

                  <div className="mb-4">
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">On Leave</span>
                      <strong>{dashboardData.onLeave}</strong>
                    </div>

                    <div className="progress" style={{ height: "8px" }}>
                      <div
                        className="progress-bar bg-warning"
                        style={{ width: `${leavePercentage}%` }}
                      ></div>
                    </div>

                    <small className="text-warning">{leavePercentage}%</small>
                  </div>

                  <div className="alert alert-primary mb-0">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-clock-history fs-4 me-3"></i>
                      <div>
                        <small className="d-block">
                          Average Working Time
                        </small>
                        <strong className={
                          Number(dashboardData.averageWorkingSeconds) >=
                            Number(dashboardData.requiredWorkingSeconds / 1.2)
                            ? ""
                            : "text-danger"
                        } >
                          {formatWorkingTime(
                            dashboardData.averageWorkingSeconds
                          )}
                        </strong>
                        <hr></hr>
                        <span>
                          Total Required:{" "}
                          {formatWorkingTime(
                            dashboardData.requiredWorkingSeconds
                          )}
                        </span>
                        <br></br>
                        <span>
                          <strong>
                            Minimum Required:{" "}
                            {formatWorkingTime(
                              dashboardData.requiredWorkingSeconds / 1.2
                            )}
                          </strong>
                        </span>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>

          {/* Attendance Table */}
          <div className="card border-0 shadow-sm">

            <div className="card-body">

              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h5 className="fw-bold mb-1">
                    Today's Attendance
                  </h5>

                  <p className="text-muted small mb-0">
                    Employee attendance records
                  </p>
                </div>

                {/*   <button className="btn btn-outline-primary btn-sm">
              View All
            </button>*/ }
              </div>

              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">

                  <thead className="table-light">
                    <tr>
                      <th>Employee</th>
                      <th>Working Hours</th>
                      <th>Report</th>

                    </tr>
                  </thead>

                  <tbody>
                    {employees.map((employee, index) => (
                      <tr key={index}>

                        <td>
                          <div className="d-flex align-items-center">

                            <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: "40px",
                                height: "40px",
                              }}
                            >
                              {employee.name.charAt(0)}
                            </div>

                            <div>
                              <div className="fw-semibold">
                                {employee.name}
                              </div>

                              <small className="text-muted">
                                {employee.emailid}
                              </small>
                            </div>

                          </div>
                        </td>




                        <td>
                          <span className="fw-semibold">
                            {formatWorkingTime(employee.workingMinutes)}
                          </span>
                        </td>

                        <td><Link className='btn btn-primary btn-sm' to={"/employee-record/" + employee._id}>Report</Link></td>






                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>

            </div>

          </div>

        </section>

      )
      }

    </>


  );
}

export default Dashboard 